import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setSelectedSuperWifi, setSelectedSuperWifiReplace, setErrorText, reportDWH, setLeadPage } from '../saleJetBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync } from '../saleBlockAsyncThunk';
import SuperWifi from '../Partials/SuperWifi/SuperWifi';

const SuperWifiPage = (props) => {

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let title = '';
  let subTitle = '';
  let remark = '';

  if (props.orderType == 'replace') {
    const price = sum(props.superWifiList.filter(x => x.action == 'Add'), 'price');
    title = (<> היי {props._authentication.loginData.userDetails.firstName}, <br /> שמנו לב שיש לך במנוי סופר WiFi </>);
    subTitle = (<> רצינו לעדכן שבהתאם לשדרוג החבילה שלך <br /> מחיר הסופר וייפי יעודכן  </>);
    remark = (<> המחיר החדש יהיה - ₪{price} </>);
  }
  else {
    title = (<> בבתים גדולים או מרובי קומות <br /> מומלץ להגדיל את טווח הקליטה של הWiFi </>);
    subTitle = 'האם יש לך צורך בסופר WiFi?';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
      {remark && <div className='sale-remark-bold'> {remark} </div>}
    </div>
  );

  let currentPageView = <SuperWifi error={props.errorText} superWifiList={props.superWifiList} onSelectSuperWifi={handleSelectSuperWifi} superWifiImage={props.superWifiImage} superWifiPopupText={props.superWifiPopupText} isLoadingShoppingCart={props.isLoadingShoppingCart} orderType={props.orderType} />;

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handleSelectSuperWifi(superWifi) {

    props.setErrorText("");

    if (props.orderType == 'replace') {
      props.setSelectedSuperWifiReplace(superWifi);
    }
    else {
      props.setSelectedSuperWifi(superWifi);
      props.getSalePricesAsync();
    }

  }

  function handlePageContinue() {
    if (!props.isSelectedSuperWifi) {
      props.setErrorText('אנא בחר אחת מן האפשרויות');
      return;
    }

    if (props.isSelectedSuperWifiLead) {
      props.setLeadPage('superWifiLead');
      return;
    }

    if (props.saleType == 'triple') {
      props.goToPage('convertersPage');
    }
    else {
      const { routerInfo } = props.selectedPackage;
      const { nameRouterUpgrade} = routerInfo;
      const wifiRouterStarPro = props.routers?.find(router => router.name === nameRouterUpgrade.value);
      if(props.addons >= 1 && wifiRouterStarPro === undefined){
        props.goToPage('addonsPage');
      }else if (props.saleType == 'internet') {
        props.goToPage('internetCustomerInfoPage');
      } else {
        props.getTechnicianTimesAsync();
      }
    }
  }

  function sum(items, prop) {
    if (!items || items.length == 0) { return 0; }

    return items.reduce(function (a, b) {
      return a + parseFloat(b[prop]);
    }, 0);
  };

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    orderType: state.saleJetBlock.orderType,
    offerName: state.saleJetBlock.offerName,
    superWifiList: state.saleJetBlock.saleCatalog?.superWifiList,
    addons:  state.saleJetBlock.saleCatalog?.addons,
    routers: state.saleJetBlock.saleCatalog?.routers,
    superWifiImage: state.saleJetBlock.saleBlockData.superWifiImage,
    superWifiPopupText: state.saleJetBlock.saleBlockData.superWifiPopupText,
    selectedSuperWifi: state.saleJetBlock.selectedSuperWifi,
    isSelectedSuperWifi: state.saleJetBlock.isSelectedSuperWifi,
    errorText: state.saleJetBlock.errorText,
    isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
    selectedPackage: state.saleJetBlock.selectedPackage,
    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedSuperWifi,
  setSelectedSuperWifiReplace,
  getSalePricesAsync,
  getTechnicianTimesAsync,
  setErrorText,
  reportDWH,
  setLeadPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperWifiPage);
